"use client";

import { getOpenInBrowserCopy } from "@/const/openInBrowserTranslations";
import { useMustOpenInBrowser } from "@/lib/inAppEscape/InAppEscapeContext";

function getRedirectDestination(os: string) {
  if (os === "ios") return "App Store";
  if (os === "android") return "Google Play";
  return "the app page";
}

function getFallbackInstruction(os: string) {
  if (os === "ios") {
    return "If it doesn't open automatically, use the App Store button below.";
  }

  if (os === "android") {
    return "If it doesn't open automatically, use the Google Play button below.";
  }

  return "If it doesn't open automatically, use the button below.";
}

const PARAGRAPH_CLASS = `
  w-70 text-sm text-slate-500
  system-dark:text-zinc-400
`;

export function RedirectAlreadyRedirected({
  os,
  iosUrl,
}: {
  os: string;
  iosUrl: string | null;
}) {
  const mustOpenInBrowser = useMustOpenInBrowser(iosUrl);

  // This screen only ever renders after the client has taken over, so reading
  // the browser language here cannot disagree with the server's HTML.
  const openInBrowser = getOpenInBrowserCopy(
    typeof navigator === "undefined" ? "en" : navigator.language
  );

  if (mustOpenInBrowser) {
    return (
      <div className="mb-4 flex flex-col items-center gap-2 text-center">
        <p className={PARAGRAPH_CLASS}>{openInBrowser.blocked}</p>
        <p className={PARAGRAPH_CLASS}>{openInBrowser.instruction}</p>
      </div>
    );
  }

  return (
    <div className="mb-4 flex flex-col items-center gap-2 text-center">
      <p className={PARAGRAPH_CLASS}>
        {`Proceeding with ${getRedirectDestination(os)}...`}
      </p>
      <p className={PARAGRAPH_CLASS}>{getFallbackInstruction(os)}</p>
    </div>
  );
}
